/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_ContinueInputs */

const cs_auth_meta_continue = /** @type {(inputs: Auth_Meta_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokračovat přes Meta`)
};

const en_auth_meta_continue = /** @type {(inputs: Auth_Meta_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Meta`)
};

/**
* | output |
* | --- |
* | "Continue with Meta" |
*
* @param {Auth_Meta_ContinueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_meta_continue = /** @type {((inputs?: Auth_Meta_ContinueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_ContinueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_meta_continue(inputs)
	return cs_auth_meta_continue(inputs)
});